import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout';
import classes from "./UserBlacklist.module.css";
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { blacklistMsisdnApi, getBlacklistNumbersApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment-timezone";
import BlacklistConfirmationModal from '../components/BlacklistConfirmationModal';
import { useNavigate } from 'react-router-dom';
import { removeToken } from '../store/slices/tokenSlice';
import { toast } from 'react-toastify';
import Spinner from '../components/Spinner';

const UserBlacklist = () => {
    const [msisdn, setMsisdn] = useState("");
    const { tokenData } = useSelector(state => state?.tokenSlice);
    const [blacklistedNumbers, setBlacklistedNumbers] = useState([]);
    const [modal, setModal] = useState(false);

    const [loading, setLoading] = useState(true);
    const [unsubLoading, setUnsubLoading] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchBlacklistedNumbers = async () => {
        try {
            setLoading(true);
            const response = await getBlacklistNumbersApi(tokenData);
            console.log(response);
            setBlacklistedNumbers(response?.data?.result);
            setLoading(false);

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }

        }
    }

    const blacklistMsisdn = async () => {
        try {
            setUnsubLoading(true);
            const response = await blacklistMsisdnApi(msisdn, tokenData);
            console.log(response?.data?.result, 'response...');
            setUnsubLoading(false);
            setModal(false);

            if (response?.data?.result?.status == 0) {
                toast.info("Msisdn is already blacklisted!");
            }
            else {
                fetchBlacklistedNumbers();
                toast.success("Msisdn blacklisted successfully!");
            }
        } catch (error) {
            console.log(error, 'error---');
            setUnsubLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        fetchBlacklistedNumbers();
    }, []);

    return (
        <Layout active={2}>

            <div className={classes.message_container}>
                <p className={classes.message_title}>Blacklist Numbers</p>
            </div>

            <div className={classes.input_container}>
                <InputNumber value={msisdn} onValueChange={(e) => setMsisdn(e.value)} useGrouping={false} placeholder="Enter User Number"
                />
                <Button label='Confirm' onClick={() => {
                    if (!msisdn) {
                        return;
                    }
                    setModal(true)
                }
                } />
            </div>

            {loading ? <Spinner /> : (
                <div className={classes.table_container}>
                    <DataTable
                        value={[...blacklistedNumbers]}
                        emptyMessage="No Data Found!"
                        showGridlines
                        responsive
                        scrollable
                        scrollDirection="both"
                        header={
                            <p className={classes.table_header}>
                                List of Blacklisted Numbers
                            </p>
                        }
                        scrollHeight="500px"
                    >
                        <Column
                            field="msisdn"
                            header="Msisdn"
                        />
                        <Column field="date_time" header="Date"
                            body={(rowData) =>
                                moment(rowData?.date_time).format("DD-MM-YYYY")
                            }
                        />
                    </DataTable>
                </div>
            )}


            {modal &&
                <BlacklistConfirmationModal setModal={setModal} msisdn={msisdn} blacklistMsisdn={blacklistMsisdn}
                    unsubLoading={unsubLoading}
                />
            }
        </Layout>
    )
}

export default UserBlacklist